import { useEffect, useState, type ReactNode } from 'react';
import type { Session, SessionUser } from '../lib/session';
import { SessionContext } from './session-context';

export function SessionProvider({ session, children }: { session: Session; children: ReactNode }) {
  const [user, setUser] = useState<SessionUser | null | undefined>(undefined);
  useEffect(() => session.onChange(setUser), [session]);
  return <SessionContext.Provider value={{ session, user }}>{children}</SessionContext.Provider>;
}
